/* tslint:disable */
/* eslint-disable */
/**
 * Optimizely Flags Scheduling API
 * This page documents how to use Optimizely Flags Scheduling API. These APIs allow you to turn a flag on/off, turn a  rule on/off, change the traffic allocation of a rule and change the audience conditions of a rule. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    HTTPValidationError,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    ScheduledChange,
    ScheduledChangeFromJSON,
    ScheduledChangeToJSON,
    ScheduledChangeUpdateRequest,
    ScheduledChangeUpdateRequestFromJSON,
    ScheduledChangeUpdateRequestToJSON,
} from '../models';

export interface DeleteScheduledChangeRequest {
    project_id: number;
    flag_key: string;
    schedule_id: number;
}

export interface UpdateScheduledChangeRequest {
    project_id: number;
    flag_key: string;
    schedule_id: number;
    scheduled_change_update_request: ScheduledChangeUpdateRequest;
}

/**
 * no description
 */
export class ScheduledChangeApi extends runtime.BaseAPI {

    /**
     * Delete a Scheduled Change for a flag in an environment 
     * Delete a Scheduled Change for a flag in an environment
     */
    async deleteScheduledChangeRaw(requestParameters: DeleteScheduledChangeRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling deleteScheduledChange.');
        }

        if (requestParameters.flag_key === null || requestParameters.flag_key === undefined) {
            throw new runtime.RequiredError('flag_key','Required parameter requestParameters.flag_key was null or undefined when calling deleteScheduledChange.');
        }

        if (requestParameters.schedule_id === null || requestParameters.schedule_id === undefined) {
            throw new runtime.RequiredError('schedule_id','Required parameter requestParameters.schedule_id was null or undefined when calling deleteScheduledChange.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/projects/{project_id}/flags/{flag_key}/schedules/{schedule_id}`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"flag_key"}}`, encodeURIComponent(String(requestParameters.flag_key))).replace(`{${"schedule_id"}}`, encodeURIComponent(String(requestParameters.schedule_id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a Scheduled Change for a flag in an environment 
     * Delete a Scheduled Change for a flag in an environment
     */
    async deleteScheduledChange(requestParameters: DeleteScheduledChangeRequest): Promise<void> {
        await this.deleteScheduledChangeRaw(requestParameters);
    }

    /**
     * Update the Scheduled Change for a flag in an environment 
     * Update the Scheduled Change for a flag in an environment
     */
    async updateScheduledChangeRaw(requestParameters: UpdateScheduledChangeRequest): Promise<runtime.ApiResponse<ScheduledChange>> {
        if (requestParameters.project_id === null || requestParameters.project_id === undefined) {
            throw new runtime.RequiredError('project_id','Required parameter requestParameters.project_id was null or undefined when calling updateScheduledChange.');
        }

        if (requestParameters.flag_key === null || requestParameters.flag_key === undefined) {
            throw new runtime.RequiredError('flag_key','Required parameter requestParameters.flag_key was null or undefined when calling updateScheduledChange.');
        }

        if (requestParameters.schedule_id === null || requestParameters.schedule_id === undefined) {
            throw new runtime.RequiredError('schedule_id','Required parameter requestParameters.schedule_id was null or undefined when calling updateScheduledChange.');
        }

        if (requestParameters.scheduled_change_update_request === null || requestParameters.scheduled_change_update_request === undefined) {
            throw new runtime.RequiredError('scheduled_change_update_request','Required parameter requestParameters.scheduled_change_update_request was null or undefined when calling updateScheduledChange.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/projects/{project_id}/flags/{flag_key}/schedules/{schedule_id}`.replace(`{${"project_id"}}`, encodeURIComponent(String(requestParameters.project_id))).replace(`{${"flag_key"}}`, encodeURIComponent(String(requestParameters.flag_key))).replace(`{${"schedule_id"}}`, encodeURIComponent(String(requestParameters.schedule_id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ScheduledChangeUpdateRequestToJSON(requestParameters.scheduled_change_update_request),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ScheduledChangeFromJSON(jsonValue));
    }

    /**
     * Update the Scheduled Change for a flag in an environment 
     * Update the Scheduled Change for a flag in an environment
     */
    async updateScheduledChange(requestParameters: UpdateScheduledChangeRequest): Promise<ScheduledChange> {
        const response = await this.updateScheduledChangeRaw(requestParameters);
        return await response.value();
    }

}
